<template>
  <button v-on="$listeners" v-bind="$attrs" :class="['btn', {'btn-1': primary, 'btn-2': !primary}]"><slot>{{text}}</slot></button>
</template>

<script>
export default {
  props: {
    text: String,
    primary: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style>

</style>